import { legacyTheme, styled } from '@prose-ui/legacy';

import { Rating } from 'Components/Rating';
import { Typography } from 'Components/Typography';

const ReviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${legacyTheme.width.veryWide};
`;

const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

const Stars = styled.div`
  display: flex;
  flex-flow: column;
  zoom: 0.6;
`;

const ReviewEntry = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const RatingLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: calc(-1 * 12px);
  margin-right: calc(-1 * 12px);

  & > * {
    margin-right: 12px;
    margin-left: 12px;
  }
`;

type UserReviewProps = {
  displayName: string;
  ratings: [number, string][];
  text: string;
  date: string;
};

export const Review = ({ displayName, ratings, text, date }: UserReviewProps) => (
  <ReviewWrapper>
    <Heading>
      <Typography align="left" color="noir" markupName="p" paragraph variant="h3">
        {displayName}
      </Typography>

      <Typography align="left" color="noir" paragraph variant="p2">
        Feedback left on {date}
      </Typography>
    </Heading>
    <ReviewEntry>
      <Typography align="left" color="grey" variant="p2">
        {text}
      </Typography>
    </ReviewEntry>
    {ratings.map(([rating, label]) => (
      <RatingLine key={String(label)}>
        {rating && (
          <Stars>
            <Rating best={5} score={rating} worst={1} />
          </Stars>
        )}

        <Typography color="noir" markupName="span" variant="p2">
          {label}
        </Typography>
      </RatingLine>
    ))}
  </ReviewWrapper>
);
